import React, { useState } from "react";
import {
  ShortAnswer,
  MultipleChoice,
  CheckBox,
  CheckBoxImage,
  LineScale,
  GridBox,
  CheckBoxGrid,
  Document,
  Name,
  Website,
  Email,
  Signature,
  Phone,
  Ratings,
  DateAndTime,
  Date,
  ParagraphAnswer,
  Number,
  Spinner,
  Dropdown,
  VAFileUpload,
  FileUpload,
  Location,
} from "./QuestionResponse/QuestionResponseComponent";
import sample_signer_image from "../../../Assets/sample_signer_image.png";
import fronticon from "../../../Assets/frontIcon.svg";
import back_icon from "../../../Assets/back_icon.svg";
import caret_down_icon from "../../../Assets/caret-down_icon.svg";
import { useSelector } from "react-redux";

const QuestionView = ({ questionViewFrom }) => {
  console.log("questionViewFrom",questionViewFrom)
  const responses = questionViewFrom?.form?.sections
  .flatMap((section) => section || [])
  .flatMap((data) => data.questions || [])
  .map((ques) => ques);
  
  const [currentIndex, setCurrentIndex] = useState(0);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const truncateText = (text, maxLength) => {
    if (text?.length <= maxLength) {
      return text;
    }
    return text?.slice(0, maxLength) + "...";
  };
  const maxLength = 25;

  const handleSelectChange = (index) => {
    setCurrentIndex(index);
    setDropdownOpen(false);
  };
  const goToNext = () => {
    if (currentIndex < responses.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? responses.length - 1 : prevIndex - 1
    );
  };

  const renderQuestion = () => {
    const response = responses[currentIndex];
    const i = currentIndex;
    switch (response?.type) {
      case "Short Answer":
        return <ShortAnswer response={response} index={i} />;
      case "Paragraph":
        return <ParagraphAnswer response={response} index={i} />;
      case "Name":
        return <Name response={response} index={i} />;
      case "Multiple Choice":
        return <MultipleChoice response={response} index={i} />;
      case "Check box":
        return <CheckBox response={response} index={i} />;
      case "Check box image":
        return <CheckBoxImage response={response} index={i} />;
      case "Line Scale":
        return <LineScale response={response} index={i} />;
      case "Multiple Choice grid":
        return <GridBox response={response} index={i} />;
      case "Check box grid":
        return <CheckBoxGrid response={response} index={i} />;
      case "Document":
        return <Document response={response} index={i} />;
      case "Website":
        return <Website response={response} index={i} />;
      case "Email":
        return <Email response={response} index={i} />;
      case "Signature":
        return <Signature response={response} index={i} />;
      case "Phone":
        return <Phone response={response} index={i} />;
      case "Number":
        return <Number response={response} index={i} />;
      case "Ratings":
        return <Ratings response={response} index={i} />;
      case "Date - Time":
        return <DateAndTime response={response} index={i} />;
      case "Date":
        return <Date response={response} index={i} />;
      case "Spinner":
        return <Spinner response={response} index={i} />;
      case "Dropdown":
        return <Dropdown response={response} index={i} />;
      case "Audio/Video Upload":
        return <VAFileUpload response={response} index={i} />;
      case "File Upload":
        return <FileUpload response={response} index={i} />;
      case "Location":
        return <Location response={response} index={i} />;

      default:
        return null;
    }
  };
  return (
    <div className="QuestionView">
      <div className="responce_questionView_container">
        <div className="navigation-container">
          <div className="navigation_numer-container">
            <button
              disabled={currentIndex === 0}
              onClick={goToPrevious}
              style={{
                display: "flex",
                backgroundColor: "rgba(27, 81, 187, 0.04)",
                borderRadius: "2rem",
                alignItems: "center",
                gap: "0.7rem",
                padding: "0.5rem 1rem",
                cursor: "pointer",
                marginTop: "0px",
              }}
            >
              <img src={back_icon} alt="back_icon" /> {currentIndex + 1}
            </button>
            <p> of</p>
            <button
              onClick={goToNext}
              style={{
                display: "flex",
                gap: "0.7rem",
                alignItems: "center",
                backgroundColor: "rgba(27, 81, 187, 0.04)",
                borderRadius: "2rem",
                padding: "0.5rem 1rem",
                cursor: "pointer",
                marginTop: "0px",
              }}
            >
              {responses?.length}
              <img src={fronticon} alt="fronticon" />
            </button>
          </div>
          <div className="custom-dropdown fixed-width">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="dropdown-toggle"
              style={{ marginTop: "0px" }}
            >
              {responses?.length > 0 &&
                truncateText(
                  responses[currentIndex]?.question?.replace(/<[^>]*>/g, ""),
                  maxLength
                )}
              <img
                src={caret_down_icon}
                alt="caret-down_icon"
                className="dropdown-icon"
              />
            </button>
            {dropdownOpen && (
              <ul className="dropdown-menu">
                {responses.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => handleSelectChange(index)}
                    className={`dropdown-item ${
                      index === currentIndex ? "active" : ""
                    }`}
                  >
                    {truncateText(
                      item.question.replace(/<[^>]*>/g, ""),
                      maxLength
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        <div>{renderQuestion()}</div>
      </div>
    </div>
  );
};

export default QuestionView;
